The scheme ID of the hirers.

Currently, only `seekAnz` and `seekAnzPublicTest` are supported.
